import {Log} from './log.js'

const SilverBase = require('silver-base')
const ScrollListUI = require('silver-scroll-list')

function getQU(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}

function nowDate() {
    const D = new Date()
    const YYYY = D.getFullYear() + ''
    let MM = D.getMonth() + 1 + ''
    if (MM.length === 1) {
        MM = '0' + MM
    }
    let DD = D.getDate() + ''
    if (DD.length === 1) {
        DD = '0' + DD
    }
    let HH = D.getHours() + ''
    if (HH.length === 1) {
        HH = '0' + HH
    }
    let mm = D.getMinutes() + ''
    if (mm.length === 1) {
        mm = '0' + mm
    }
    let ss = D.getSeconds() + ''
    if (ss.length === 1) {
        ss = '0' + ss
    }
    return YYYY + '-' + MM + '-' + DD + ' ' + HH + ':' + mm + ':' + ss
}

class SilverArk extends SilverBase {
    constructor(opt) {
        super(opt)
    }

    __setDefaultData(opt) {
        if (!opt) {
            opt = {}
        }
        let data = this.optToData(opt)
        if (!data) {
            data = {}
        }
        this.__logName__ = opt.name || null
        data.target = MainScroll.getContent(opt.target)
        data.logName = this.__logName__
        if (opt.defaultFocus) {
            data.defaultFocus = opt.defaultFocus === '是' ? true : false
        }
        if (opt.focusType) {
            let focusType = null
            if (opt.focusType === '顶头') {
                focusType = 1
            } else if (opt.focusType === '贴尾') {
                focusType = 2
            }
            data.focusType = focusType
        }
        return data
    }

    __bind() {
        this.on('destroy', function () {
            this.destroyStart()
        }.bind(this))
    }

    /**
     * getName 获取组件名称
     * @memberOf SilverArk.prototype
     * @method getName
     * @return {String}
     */
    getName() {
        return 'SilverArk'
    }

    init() {

    }

    optToData(data) {
        return data
    }

    log(eventName, param) {
        if (!this.__logName__) {
            return this
        }
        const log = {
            widgetName: this.__logName__,
            eventName: eventName,
            eventId: eventName
        }
        log[this.__logName__] = eventName
        if (typeof param === 'object') {
            for (let k in param) {
                if (param.hasOwnProperty(k) && !log[k]) {
                    log[k] = param[k]
                }
            }
        }
        Log.event(log)
    }

    debugLog(text) {
        if (text && window.__debugLog__ && (window.__debugLog__ === 'all' || window.__debugLog__ === this.__logName__)) {
            console.log('[ ARK ] DEBUG time:[' + nowDate() + '] widget_name:[' + this.__logName__ + '] : ' + text)
        }
    }

    getOnlyName() {
        return this.__logName__ || this.getId()
    }

    redraw() {

    }

    redrawByOption(opt) {
        const data = this.__setDefaultData(opt)
        this.redraw(data)
        this.fire('redrawByOption', data)
    }

    destroyStart() {

    }
}

/** scroll **/
class ScrollList extends SilverArk {
    constructor(opt) {
        super(opt)
        const data = this.__setDefaultData(opt)
        this.data = data
        this.init(data, opt)
        this.__bind()
    }

    getName() {
        return 'ScrollList'
    }

    optToData(opt) {
        let style = opt.style || {};
        let position = opt.position || {};
        let __position__ = false
        if (opt.__position__ === '流式') {
            __position__ = true
        }
        return {
            left: parseInt(position.left),
            top: parseInt(position.top),
            zIndex: parseInt(position.zIndex),
            width: parseInt(style.width),
            height: parseInt(style.height),
            bgColor: style.bgColor,
            bgImg: style.bgImg,
            bgImgMove: style.bgImgMove,
            paddingBottom: style.paddingBottom,
            data: opt.data,
            __position__: __position__
        }
    }

    init(data) {
        this.scroll = new ScrollListUI(data)
    }

    scrollListTo(num) {
        this.scroll.getFocusEngineComponent().scrollListTo(num, 0)
    }

    redraw(data) {
        this.scroll.renderByOption(data);
    }

    destroyStart() {
        this.scroll.destroy();
    }
}

const MainScroll = {
    list: [],
    init(data) {
        let _data = {}
        if (data) {
            _data.style = data
        } else {
            _data.style = {}
        }
        _data.data = {
            className: 'scroll-body',
            listClassName: 'body-scroll-list',
            isNoCache: true
        }
        this.addScroll(_data)
    },
    addScroll(data) {
        const s = new ScrollList(data)
        if (s) {
            this.list = this.list.concat(s)
        }
        return s
    },
    removeScroll(index) {
        if (typeof index === 'number' && !isNaN(index) && this.list[index]) {
            this.list.splice(index, 1)
        }
        return this
    },
    getWidget(index) {
        let s = null
        index = parseInt(index, 10)
        if (typeof index === 'number' && !isNaN(index)) {
            s = this.list[index]
            if (!s) {
                s = this.list[0]
            }
        } else {
            s = this.list[0]
        }
        return s
    },
    getScroll(index) {
        let s = this.getWidget(index).scroll

        if (s && s.getScroll) {
            return s.getScroll()
        }
        return null
    },
    getScrollList(arr) {
        let viewArr = []
        const _this = this
        if (arr && Array.isArray(arr)) {
            arr.forEach(function (item) {
                viewArr.push(_this.getWidget(item))
            })
        }
        return viewArr
    },
    getContent(index) {
        let s = this.getWidget(index)
        if (s && s.scroll && s.scroll.getScrollList) {
            return s.scroll.getScrollList()
        }
        return document.querySelector('.alitv-h5-system')
    }
};

export const ARK = {
    base: SilverArk,
    mainScroll: MainScroll,
    scrollListInit(data) {
        MainScroll.init(data)
    },
    ScrollList(opt) {
        return new ScrollList(opt)
    },
    getScroll() {
        return MainScroll.getScroll()
    },
    addScroll(data) {
        return MainScroll.addScroll(data)
    },
    log(eventId, param) {
        param = param || {}
        param.widgetName = param.widgetName || 'code';
        console.log(param);
        this._log(eventId, param)
    },
    _log(eventId, param) {
        param = param || {}
        param.eventId = eventId
        param.eventName = eventId
        param.fromName = getQU("from") || '';
        console.log(param);
        Log.event(param)
    },
    exposure(eventId, param) {
        param = param || {}
        param.eventId = eventId
        param.eventName = eventId
        param.fromName = getQU("from") || '';
        Log.exposure(param)
    },
    setGlobal(data) {
        Log.setGlobal(data)
    }
}



// WEBPACK FOOTER //
// ./src/page/main/ark.js